import { FormattedMessage } from 'react-intl';
import React from 'react';
import { FlexRow } from 'ui-components/components/flex';

import { NewFeatureBadge } from '../../../pages/settings/components/new-feature-badge';
import { SHIPPED_VIEW_ID, REFUND_ASSIST_VIEW_ID } from './view-id-constants';

import { messages } from '../messages';
import style from './style.module.less';

export const RefundAssist = {
  label: (
    <FlexRow className={style['nav-item-with-badge']}>
      <FormattedMessage {...messages.shipmentRefundAssistNavItemLabel} />
      <NewFeatureBadge />
    </FlexRow>
  ),

  id: REFUND_ASSIST_VIEW_ID,
  expandedDescription: <FormattedMessage {...messages.shipmentRefundAssistPageTitle} />,
  parentId: SHIPPED_VIEW_ID,
};
